import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
    return axiosIns.get(`/role-mapping?${args}`);
};

export const ADD_DATA = (args) => {
    return axiosIns.post("/role-mapping/create", args);
};

export const UPDATE_DATA = (args) => {
    return axiosIns.put(`/role-mapping/update?id=${args.id}`, {
        roles_id: args.roles_id
    });
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/role-mapping/${id}/delete`);
};
